export default {
    groceryTools: {
        name: 'icon-grocery-w',
        black: 'icon-grocery-b15x',
        colour: '#267A03',
    },
    alerts: {
        name: 'icon-Alerts-w',
        black: 'icon-Alerts-b15x',
        colour: '#E1333A',
    },
    admin: {
        name: 'icon-Admin-w',
        black: 'icon-admin-b15x',
        colour: '#2E2F32',
    },
    extadmin: {
        name: 'icon-EA-w',
        black: 'icon-EA-415x',
        colour: '#46474A',
    },
    distManagement: {
        name: 'icon-DM-w',
        black: 'icon-DM-b15x',
        colour: '#113601',
    },
    offerLogistics: {
        name: 'icon-OL-w',
        black: 'icon-OL-b15x',
        colour: '#3B1E4C',
    },
    returns: {
        name: 'icon-returns-b15x',
        black: 'icon-returns-b15x',
        colour: '#C83C00',
    },
    sourcing: {
        name: 'icon-PS-w',
        black: 'icon-PS-b15x',
        colour: '#851116',
    },
    transport: {
        name: 'icon-Shipping-18',
        black: 'icon-Shipping-18',
        colour: '#FFC836',
    },
    oms: {
        name: 'icon-OM-w',
        black: 'icon-OM-b15x',
        colour: '#FB741A',
    },
    inventory: {
        name: 'icon-IM-w',
        black: 'icon-IM-b15x',
        colour: '#005AB0',
    },
    dashboard: {
        name: 'icon-Dash-w',
        black: 'icon-Dash-b15x',
        colour: '#49006A',
    },
    deliverytools: {
        name: 'icon-Configuration-181x',
        black: 'icon-Configuration-181x',
        colour: '#00172C',
    },
    fulfilManagement: {
        name: 'icon-FOCI-w',
        black: 'icon-FOCI-b15x',
        colour: '#995213',
    },
    gm: {
        name: 'icon-GM-w',
        black: 'icon-GM-b15x',
        colour: '#00172C',
    },
    sortation: {
        name: 'icon-Shuffle-18',
        black: 'icon-Shuffle-18',
        colour: '#B72882',
    },
    returnOverride: {
        name: 'icon-ReturnsOver-w',
        black: 'icon-ReturnsOver-b15x',
        colour: '#C83C00',
    },
    nextGenPrinting: {
        name: 'icon-PL-w',
        black: 'icon-PL-b15x',
        colour: '#452358',
    },
    freight: {
        name: 'icon-FM-b15x',
        black: 'icon-FM-b15x',
        colour: '#FFD463',
    },
    score: {
        name: 'icon-Score-w15x',
        black: 'icon-Score-b15x',
        colour: '#E15300',
    },
    fcap: {
        name: 'icon-FC-w15x',
        black: 'icon-FC-b15x',
        colour: '#281432',
    },
    asda: {
        name: 'icon-Asda-w15x',
        black: 'icon-Asda-w15x',
        colour: '#3F931C',
    },
    prism: {
        name: 'icon-prism-w15x',
        black: 'icon-prism-w-Copy15x',
        colour: '#51123A',
    },
    rpo: {
        name: 'icon-RPO-w15x',
        black: 'icon-RPO-b15x',
        colour: '#267A03',
    },
    daas: {
        name: 'icon-Del-w',
        black: 'icon-Del-b15x',
        colour: '#195102',
    },
    gif: {
        name: 'icon-GIF-w',
        black: 'icon-GIF-b15x',
        colour: '#0071DC',
    },
    fleetManagement: {
        name: 'icon-Trans-w',
        black: 'icon-Trans-b15x',
        colour: '#E6A31D',
    },
    trackAndTrace: {
        name: 'icon-TrackTrace-w',
        black: 'icon-TrackTrace-b',
        colour: '#0066C6',
    },
    reverselogistics: {
        name: 'icon-Rev-w',
        black: 'icon-Rev-b15x',
        colour: '#004484',
    },
    swarm: {
        name: 'icon-swarm-w',
        black: 'icon-swarm-b15x',
        color: '#6F0E12',
    },
    tipping: {
        name: 'icon-Tip-w',
        black: 'icon-Tip-b15x',
        color: '#C81920',
    },
};
